export const socialsIcons = {
  github: (className) => <i className={`uil uil-github-alt ${className}`}></i>,
  facebook: (className) => (
    <i className={`uil uil-facebook-f ${className}`}></i>
  ),
  insta: (className) => <i className={`uil uil-instagram ${className}`}></i>,
};
